import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Boxes from './Draw_Boxes.mixin'
import lmx_Lines from './Draw_LineCharts.mixin'
import lmx_Legend from './Draw_Legends.mixin'
import lmx_Tool from './Draw_Toolbar.mixin'
import lmx_Table from './Draw_Table.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    lmx_Boxes,
    lmx_Lines,
    lmx_Legend,
    lmx_Tool,
    lmx_Table,

  ],
}
